import { render } from "./tabs_nav.vue?vue&type=template&id=36096562"
import script from "./tabs_nav.vue?vue&type=script&lang=js"
export * from "./tabs_nav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/nav/tabs_nav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36096562"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36096562', __exports__)) {
    api.reload('36096562', __exports__)
  }
  
  module.hot.accept("./tabs_nav.vue?vue&type=template&id=36096562", () => {
    api.rerender('36096562', render)
  })

}


export default __exports__